import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { FacilityUsersFetchedAction } from '@Application/Users/FacilityUsers/Actions/facilityUsersFetched';
import FacilityUserView from '@UI/Store/FacilityUsers/Views/FacilityUserView';
import FacilityUsersListView from '@UI/Store/FacilityUsers/Views/FacilityUsersListView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type FacilityUsersStore = {
	users: FacilityUsersListView | null;
};

const initialState: FacilityUsersStore = {
	users: null,
};

type Actions = FacilityUsersFetchedAction | UserRevokedAction;

const whenFacilityUsersFetched = (
	store: FacilityUsersStore,
	action: FacilityUsersFetchedAction,
): FacilityUsersStore => ({
	...store,
	users: new FacilityUsersListView(
		action.payload.results.map((user) => new FacilityUserView(user)),
		action.facilityId,
	),
});

// This store carries the agency directory alongside health-related dossiers: it does not survive the
// session.
const whenUserRevoked = (): FacilityUsersStore => initialState;

export default registerStore<'facilityUsersStore', Actions>(
	'facilityUsersStore',
	createSliceReducer({
		FACILITY_USERS_FETCHED: whenFacilityUsersFetched,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
